import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { FiUserSetPasswordComponent } from './set-password.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FormsModule } from '@angular/forms';
import { FiPasswordChangeModule } from '@fi-shared/fi-password-change/fi-password-change.module';
import { FiCustomValidatorsModule } from '@fi-shared/fi-directives/fi-custom-validators/fi-custom-validators.module';
import { MatIconButton } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        FiErrorMessageModule,
        FormsModule,
        FiPasswordChangeModule,
        FiCustomValidatorsModule,
        MatIconButton,
    ],
    declarations: [FiUserSetPasswordComponent],
    exports: [FiUserSetPasswordComponent],
})
export class FiSetPasswordModule {}
